/**
 * Extract a safe display message from any error.
 *
 * This lives in domain/ so every layer (presentation, components, contexts,
 * infrastructure, application) can import it without violating boundaries.
 *
 * For richer handling of ApiClientError (clean backend messages, i18n mapping),
 * use getUserErrorMessage() from application/errors/ or mapErrorToUserFriendly().
 */
export function getErrorMessage(
	error: unknown,
	fallback = "Error desconocido",
): string {
	if (error instanceof Error) return error.message;
	return fallback;
}
